module.exports = __webpack_public_path__ + "static/media/mg_7972.ef0515df.jpg";